/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Injectable } from "@angular/core";
// /home/nvipani/valustore/src/app/shared/view-images/view-images.component.html
// import { ViewImagesComponent } from "src/app/shared/view-images/view-images.component";
import { MatDialogConfig, MatDialog } from "@angular/material/dialog";
import { ViewImagesComponent } from "../../shared/view-images/view-images.component";
import { FileUploadService } from "../common/file-upload.service";
// import { FileUploadService } from '../common/file-upload.service';
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class ImagesService {
  constructor(
    public dialog: MatDialog,
    public fileUploadService: FileUploadService
  ) {}
  getImageURL(path: string, isDefault?) {
    if (isDefault || path?.slice(0, 6) === "assets") {
      if (path.startsWith("/")) {
        return location.origin + path;
      } else {
        return location.origin + "/" + path;
      }
    } else {
      if (path) {
        if (path.slice(0, 4) === "http") {
          return path + "?random=true";
        } else {
          return environment.server + "/" + path;
        }
      }
    }
  }

  // typeImageURL --> {originalImageURL, squareImageURL, thumbnailImageURL}
  // viewProductImages(images, isListDisplay, typeImageURL?: string) {
  //   // const imagesList = [];
  //   // if (typeImageURL) {
  //   //   images.forEach(element => {
  //   //     imagesList.push(element[typeImageURL]);
  //   //   });
  //   // } else {
  //   //   imagesList.push(imagesObject);
  //   // }
  //   const dialogConfig = new MatDialogConfig();
  //   dialogConfig.disableClose = false;
  //   dialogConfig.autoFocus = false;
  //   dialogConfig.hasBackdrop = true;
  //   if (window.innerWidth > 700) {
  //     dialogConfig.maxWidth = "70vw";
  //     dialogConfig.width = "70vw";
  //     dialogConfig.maxHeight = "90vh";
  //     dialogConfig.height = "90vh";
  //     dialogConfig.position = {
  //       top: "5vh",
  //       left: "15vw"
  //     };
  //   } else {
  //     dialogConfig.maxWidth = "90vw";
  //     dialogConfig.width = "90vw";
  //     dialogConfig.maxHeight = "40vh";
  //     dialogConfig.height = "40vh";
  //     dialogConfig.position = {
  //       top: "30vh",
  //       left: "5vw"
  //     };
  //   }
  //   dialogConfig.panelClass = "nvc-override";
  //   dialogConfig.data = {
  //     productImages: images,
  //     isList: isListDisplay,
  //     imageURL: typeImageURL
  //   };
  //   console.log(dialogConfig.data);
  //   this.dialog.open(ViewImagesComponent, dialogConfig);
  // }
  viewProductImages(images, isList?, allImags?, index?, imageURL?, isDefault?) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = false;
    dialogConfig.hasBackdrop = true;
    if (window.innerWidth > 960) {
      dialogConfig.maxWidth = "70vw";
      dialogConfig.width = "70vw";
      dialogConfig.maxHeight = "90vh";
      dialogConfig.height = "90vh";
      dialogConfig.position = {
        top: "5vh",
        left: "15vw",
      };
    } else {
      dialogConfig.maxWidth = "90vw";
      dialogConfig.width = "90vw";
      dialogConfig.maxHeight = "40vh";
      dialogConfig.height = "40vh";
      dialogConfig.position = {
        top: "30vh",
        left: "5vw",
      };
    }
    dialogConfig.panelClass = "nvc-override";
    dialogConfig.data = {
      productImages: images,
      allImages: allImags,
      imageIndex: index,
      isListDisplay: isList,
      default: isDefault ? isDefault : "",
      imageURL,
    };
    console.log(dialogConfig.data);
    this.dialog.open(ViewImagesComponent, dialogConfig);
  }

  openImages(product) {
    var productImages = product.gallery.images;
    var isList = false;
    if (productImages.length > 1) {
      isList = true;
    }
    this.viewProductImages(
      productImages,
      isList,
      null,
      null,
      "originalImageURL"
    );
  }

  async updateProfileImage(uploadFiles, defaultImg?, path?, businessUnit?) {
    let attrs = {
      uploadPath: {
        nodeValue: path ? path : "users",
      },
    };
    if (businessUnit) {
      attrs["businessUnit"] = businessUnit;
    }
    const response = Object.keys(uploadFiles).map(async (element) => {
      const file = await this.fileUploadService
        .uploadFiles(attrs, uploadFiles[element].formData)
        .catch((err) => console.log(err));
      if (file) {
        console.log(file);
      }
      uploadFiles[element].formData.delete("files");
      return file;
    });
    const files = await Promise.all(response);
    if (files[0]) {
      return { profileImageURL: files[0] };
    } else {
      return { profileImageURL: defaultImg };
    }
  }

  onMouseLeave(resultID) {
    const boxes = Array.from(document.getElementsByClassName("img-zoom-lens"));
    boxes.forEach((box) => {
      box.remove();
    });
    var result = document.getElementById(resultID);
    if (result) {
      result.style.display = "none";
    }
  }

  imageZoom(imgID, resultID, resultInnerID, referenceSizeDiv) {
    var img, lens, result, innerResult, xtilesCount, ytilesCount;
    var lensSize = 100;

    let relativeSizeDiv = document.getElementById(referenceSizeDiv);
    var magnifierSize = relativeSizeDiv?.clientWidth || 500;
    var magnifierPower = magnifierSize / lensSize;

    img = document.getElementById(imgID);
    let imgActualDimensions = this.getImgSizeInfo(img);
    result = document.getElementById(resultID);
    innerResult = document.getElementById(resultInnerID);
    lens;
    if (document.getElementsByClassName("img-zoom-lens")?.length) {
      lens = document.getElementsByClassName("img-zoom-lens").item(0);
    } else {
      lens = document.createElement("DIV");
    }
    lens.setAttribute("class", "img-zoom-lens");
    img.parentElement.insertBefore(lens, img);

    xtilesCount = imgActualDimensions.width / lensSize;
    ytilesCount = imgActualDimensions.height / lensSize;

    result.style.left = relativeSizeDiv.getBoundingClientRect()?.left
      ? relativeSizeDiv.getBoundingClientRect().left + "px"
      : "60vw";
    result.style.width = magnifierSize + "px";
    result.style.height = magnifierSize + "px";
    innerResult.style.backgroundImage = "url('" + img.src + "')";
    innerResult.style.backgroundSize =
      magnifierSize * xtilesCount + "px " + magnifierSize * ytilesCount + "px";
    lens.addEventListener("mousemove", onLensMove);
    img.addEventListener("mousemove", onLensMove);

    function onLensMove(event) {
      var pos, xlensPosition, ylensPosition;
      event.preventDefault();
      pos = getCursorPos(event);
      if (
        pos.x < imgActualDimensions.left ||
        pos.x > imgActualDimensions.right ||
        pos.y < imgActualDimensions.top ||
        pos.y > imgActualDimensions.bottom
      ) {
        onMouseLeaveImage();
        return;
      }
      xlensPosition = pos.x - lensSize / 2;
      ylensPosition = pos.y - lensSize / 2;
      if (xlensPosition > imgActualDimensions.right - lensSize) {
        xlensPosition = imgActualDimensions.right - lensSize;
      }
      if (xlensPosition < imgActualDimensions.left) {
        xlensPosition = imgActualDimensions.left;
      }
      if (ylensPosition > imgActualDimensions.bottom - lensSize) {
        ylensPosition = imgActualDimensions.bottom - lensSize;
      }
      if (ylensPosition < imgActualDimensions.top) {
        ylensPosition = imgActualDimensions.top;
      }
      lens.style.left = xlensPosition + "px";
      lens.style.top = ylensPosition + "px";
      innerResult.style.backgroundPosition =
        "-" +
        (xlensPosition - imgActualDimensions.left) * magnifierPower +
        "px -" +
        (ylensPosition - imgActualDimensions.top) * magnifierPower +
        "px";
      lens.style.visibility = "visible";
      result.style.display = "block";
    }

    function getCursorPos(event) {
      var imageCoordinates,
        xCursorPos = 0,
        yCursorPos = 0;
      event = event || window.event;
      imageCoordinates = img.getBoundingClientRect();
      xCursorPos = event.pageX - imageCoordinates.left;
      yCursorPos = event.pageY - imageCoordinates.top;
      xCursorPos = xCursorPos - window.pageXOffset;
      yCursorPos = yCursorPos - window.pageYOffset;
      return { x: xCursorPos, y: yCursorPos };
    }

    function onMouseLeaveImage() {
      const boxes = Array.from(
        document.getElementsByClassName(
          "img-zoom-lens"
        ) as HTMLCollectionOf<HTMLElement>
      );
      boxes.forEach((box) => {
        box.style.visibility = "hidden";
      });
      var result = document.getElementById(resultID);
      if (result) {
        result.style.display = "none";
      }
    }
  }

  getRenderedSize(contains, cWidth, cHeight, width, height, pos) {
    var oRatio = width / height,
      cRatio = cWidth / cHeight;
    let actualSize = {};
    return function () {
      if (contains ? oRatio > cRatio : oRatio < cRatio) {
        actualSize["width"] = cWidth;
        actualSize["height"] = cWidth / oRatio;
      } else {
        actualSize["width"] = cHeight * oRatio;
        actualSize["height"] = cHeight;
      }
      actualSize["left"] =
        (cWidth - actualSize["width"]) * (parseInt(pos[0]) / 100);
      actualSize["right"] = actualSize["width"] + actualSize["left"];

      actualSize["top"] =
        (cHeight - actualSize["height"]) * (parseInt(pos[1]) / 100);
      actualSize["bottom"] = actualSize["height"] + actualSize["top"];
      return actualSize;
    }.call({});
  }

  getImgSizeInfo(img) {
    var pos = window
      .getComputedStyle(img)
      .getPropertyValue("object-position")
      .split(" ");
    return this.getRenderedSize(
      true,
      img.width,
      img.height,
      img.naturalWidth,
      img.naturalHeight,
      pos
    );
  }
}
